import type { CallbackSubscription } from '@/engine/Utilities/CallbackManager';
import type { IDisposable } from '@/engine/Utilities/IDisposable';
import type * as THREE from 'three';

export interface IFluoroAnglesIntegrationApi {
  trackCameraOrientationChanges: (callback: (quaternion: THREE.Quaternion) => void) => CallbackSubscription;
}

export interface IFluoroAnglesCalculator extends IDisposable {
  trackAngles: (callback: (raoLao: number, caudCran: number) => void) => CallbackSubscription;
}

export interface IFluoroAnglesCalculatorFactory {
  createController: (integrationApi: IFluoroAnglesIntegrationApi) => IFluoroAnglesCalculator;
}

export enum FluoroAnglesPlacement {
  ThreeD = 'ThreeD',
  Image = 'Image'
}

export type AngleLabel = 'Implant' | 'En Face' | 'Bottom Up';

export interface IAnglesValues {
  raoLao: number;
  caudCran: number;
}

export interface IAngles {
  angles: IAnglesValues;
  label: AngleLabel;
}
